module.exports = {
      id: "filter-usage",
      viewBox: "0 0 8 8",
      url: "/" + "sprite-906bd948b42f12135087bdf480fde2e1.svg#filter",
      toString: function () {
        return this.url;
      }
    }